export default __webpack_public_path__ + "static/door8-dc02ae8f983381a0a896033e0a02dbd1.jpg";